import { EventData } from "../../models/EventData";
import API from "../../services";
import { USER_API } from "../../services";
import axios from "axios";

import {
  FETCH_EVENTS_BY_SPORT_TYPE_SUCCESS,
  FETCH_EVENT_INFO_SUCCESS,
  FETCH_PREMIUM_EVENT_INFO_SUCCESS,
  INPLAY_EVENTS_BY_PROVIDER_SUCCESS,
  UPDATE_EVENT_ODDS_FROM_WS,
  SET_USER_BALANCE_SUCCESS,
  SET_USER_CURRENCY_SUCCESS,
  SET_USER_EXPOSURE_SUCCESS,
  UPDATE_EVENT_MARKETS_INFO,
  UPDATE_DREAM_EVENT_MARKETS_INFO,
  UPDATE_SECOUNDARY_MARKETS_INFO,
  UPDATE_FANCY_MARKETS_INFO,
  UPDATE_EVENTS_ODD,
  UPDATE_LIVE_EVENTS_ODD,
  UPDATE_PREMIUM_ODDS_FROM_WS,
  UPDATE_TOPIC_URLS,
  SET_IS_CONNECTED,
} from "./exchangeSportsActionTypes";
import { setLoading } from "../index";
import { connectToDreamWS, connectToWS, disconnectToWS, isConnected } from "../../websockets/websocket";
import { TopicUrls } from "../../models/sportsBookState";
import store from "../store";

export const fetchInplayEvents = () => {
  return async (dispatch: Function) => {
    try {
      dispatch(setLoading(true));
      let result = null;
      result = await API.post(`/getliveevents`, {
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
      });

      if (result && result.data.sports && result.data.sports.length > 0) {
        dispatch(setInplayEventSuccess(result.data.sports));
        dispatch(setLoading(false));
      } else {
        dispatch(setLoading(false));
        dispatch(
          setInplayEventSuccess({
            cricket: [],
            tennis: [],
            soccer: [],
          })
        );
        console.log("No Inplay events");
      }

      dispatch(setLoading(false));
    } catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };
};

export const fetchEventsBySport = (sportId: string) => {
  return async (dispatch: Function) => {
    try {
      dispatch(setLoading(true));
      let result = null;
      result = await API.post(`/getevents`, {
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
        sportId: sportId,
      });

      if (result && result.data.sports.length > 0) {
        let events: EventData[] = [];

        for (let eventData of result.data.sports) {
          if (eventData.eventId) {
            if (
              eventData.markets &&
              eventData.markets.matchOdds &&
              eventData.markets.matchOdds.length === 0
            ) {
              // Add add empty markets for fix empty in sport view
              eventData.markets.matchOdds = [
                {
                  marketId: "",
                  marketName: "",
                  marketType: "",
                  status: "",
                  runners: [
                    {
                      runnerId: "",
                      runnerName: "",
                      status: "",
                      layPrices: [
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                      ],
                      backPrices: [
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                      ],
                    },
                    {
                      runnerId: "",
                      runnerName: "",
                      status: "",
                      layPrices: [
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                      ],
                      backPrices: [
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                      ],
                    },
                    {
                      runnerId: "",
                      runnerName: "",
                      status: "",
                      layPrices: [
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                      ],
                      backPrices: [
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                        { price: 0, size: 0 },
                      ],
                    },
                  ],
                  limits: {
                    minBetValue: 0,
                    maxBetValue: 0,
                    oddsLimit: 0,
                    currency: "",
                  },
                },
              ];
            }

            events.push(eventData);
          }
        }

        let eventsData = [];
        if (sportId) {
          eventsData = events.sort((a, b) => {
            if (a.status === "IN_PLAY" && !(b.status === "IN_PLAY")) return -1;
            if (!(a.status === "IN_PLAY") && b.status === "IN_PLAY") return 1;
          });
        }

        dispatch(setEventsBySportSuccess(eventsData));

        dispatch(setLoading(false));
      } else {
        dispatch(setLoading(false));
        dispatch(setEventsBySportSuccess([]));
      }
    } catch (err) {
      dispatch(setLoading(false));
    }
  };
};

export const fetchEventInfo = (sportId: string, eventId: string) => {
  return async (dispatch: Function) => {
    try {
      dispatch(setLoading(true));
      let result = null;
      result = await API.post(`/getmarkets`, {
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
        sportId: sportId,
        eventId: eventId,
        token: sessionStorage.getItem("psAuthToken"),
      });

      if (result && result?.data) {
        dispatch(setLoading(false));
        dispatch(setEventInfoSuccess(result.data.event));
      } else {
        dispatch(setLoading(false));
      }
    } catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };
};

export const updatePremiumOddsfromWS = (payload) => {
  return {
    type: UPDATE_PREMIUM_ODDS_FROM_WS,
    payload: payload,
  };
};

const updateTopicUrlsInStore = (dispatch: Function, eventData: any) => {
  // Dispatch topic urls
  const topicUrlPayload: TopicUrls = {
    prBaseUrl: eventData?.prBaseUrl,
    prTopic: eventData?.prTopic
  }
  let topicUrls = store.getState().sportsBook.topicUrls;
  if (
    ((topicUrls.prBaseUrl &&
      eventData?.prBaseUrl &&
      topicUrls.prBaseUrl !== eventData?.prBaseUrl)
    ) && isConnected()
  ) {
    const baseUrlsPayload = {
      prBaseUrl: eventData?.prBaseUrl
    }
    disconnectToWS();
    setTimeout(() => {
      connectToWS(baseUrlsPayload);
    }, 1000);
    console.log("Base URL changed: Disconnecting Websockets")
  }
  dispatch(updateTopicUrls(topicUrlPayload));
}

export const updateTopicUrls = (payload) => {
  return {
    type: UPDATE_TOPIC_URLS,
    payload: payload,
  };
};

export const fetchPremiumEventInfo = (sportId: string, eventId: string, refresh: boolean) => {
  return async (dispatch: Function) => {
    try {
      if (refresh) {
        dispatch(setLoading(true));
      }
      let result = null;
      result = await axios.post(
        `https://scatalog.mysportsfeed.io/api/v1/feed/betfair-market-in-sr`,
        {
          operatorId: sessionStorage.getItem("psOperatorId"),
          providerId: sessionStorage.getItem("psProviderId"),
          sportId: sportId,
          eventId: eventId,
          partnerId: sessionStorage.getItem("psPartnerId"),
          token: sessionStorage.getItem("psAuthToken"),
          origin: sessionStorage.getItem("lobbyType")
        }
      );

      if (result && result?.data) {
        if (result?.data?.markets?.matchOdds?.length > 0) {
          updateTopicUrlsInStore(dispatch, result.data);
          dispatch(setPremiumEventInfoSuccess(result.data));
        } else {
          dispatch(setPremiumEventInfoSuccess({}));
        }
        dispatch(setLoading(false));
      } else {
        dispatch(setLoading(false));
      }
    } catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };
};

export const fetchBalance = () => {
  return async (dispatch: Function) => {
    try {
      let result = null;
      result = await USER_API.post(`/getuserbalance`, {
        operatorId: sessionStorage.getItem("psOperatorId"),
        providerId: sessionStorage.getItem("psProviderId"),
        partnerId: sessionStorage.getItem("psPartnerId"),
        // token: sessionStorage.getItem("authToken"),
        token: sessionStorage.getItem("user_api_token"),
      });

      if (result && result?.data.status === "RS_OK") {
        dispatch(setBalanceSuccess(result.data.balance));
        dispatch(setCurrencySuccess(result.data?.currency));
        dispatch(setExposureSuccess(result.data?.exposure));
      }
      // else {
      //   console.log('No Balance');
      // }
    } catch (err) {
      console.log(err);
    }
  };
};

const setPremiumEventInfoSuccess = (result) => {
  return {
    type: FETCH_PREMIUM_EVENT_INFO_SUCCESS,
    payload: result,
  };
};

const setInplayEventSuccess = (result) => {
  return {
    type: INPLAY_EVENTS_BY_PROVIDER_SUCCESS,
    payload: result,
  };
};

const setEventsBySportSuccess = (result) => {
  return {
    type: FETCH_EVENTS_BY_SPORT_TYPE_SUCCESS,
    payload: result,
  };
};

const setEventInfoSuccess = (result) => {
  return {
    type: FETCH_EVENT_INFO_SUCCESS,
    payload: result,
  };
};

export const setUpdateEventMarketsWS = (result) => {
  return {
    type: UPDATE_EVENT_MARKETS_INFO,
    payload: result,
  };
};

const setBalanceSuccess = (result) => {
  return {
    type: SET_USER_BALANCE_SUCCESS,
    payload: result,
  };
};

const setCurrencySuccess = (result) => {
  return {
    type: SET_USER_CURRENCY_SUCCESS,
    payload: result,
  };
};

const setExposureSuccess = (result) => {
  return {
    type: SET_USER_EXPOSURE_SUCCESS,
    payload: result,
  };
};

export const updateEventOddsfromWS = (payload) => {
  return {
    type: UPDATE_EVENT_ODDS_FROM_WS,
    payload: payload,
  };
};

export const updateDreamEventOddsWs = (payload) => {
  return {
    type: UPDATE_DREAM_EVENT_MARKETS_INFO,
    payload: payload,
  };
};

export const updateSecondaryMarkets = (payload) => {
  return {
    type: UPDATE_SECOUNDARY_MARKETS_INFO,
    payload: payload,
  };
};

export const updateFancyMarkets = (payload) => {
  return {
    type: UPDATE_FANCY_MARKETS_INFO,
    payload: payload,
  };
};

// export const updateOddsfromWS = (payload) => {
//   return {
//     type: FETCH_EVENT_BY_COMPETITION_SUCCESS,
//     payload: payload,
//   };
// };

export const setIsConnected = (payload) => {
  return {
    type: SET_IS_CONNECTED,
    payload: payload
  }
}